<template>
  <div>
    <div class="row">
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div
          :class="{
            'has-error': itemValidacao.data.$error,
          }"
          class="form-group"
        >
          <label for="data">51 - Data <sup>(1)</sup></label>
          <div id="data" class="input-group">
            <input
              id="data"
              v-model="procedimento.data"
              v-mask="'99/99/9999'"
              data-test-id="input-data"
              type="text"
              name="data"
              class="form-control input-sm"
              placeholder="Data de realização do procedimento"
              @input="itemValidacao.data.$touch()"
            />
            <div class="input-group-addon input-sm">
              <span
                type="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <span class="fa fa-calendar" />
              </span>
              <span class="dropdown-menu">
                <li>
                  <DatePicker
                    v-model="procedimento.data"
                    :today-btn="false"
                    :clear-btn="false"
                    :format="'dd/MM/yyyy'"
                    :close-on-selected="true"
                    :date-parser="dataParser"
                    class="date-picker"
                  />
                </li>
              </span>
            </div>
          </div>
          <span v-if="itemValidacao.data.$dirty">
            <span v-if="!itemValidacao.data.required" class="help-block">
              Campo obrigatório.
            </span>
          </span>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="horaInicial">52 - Hora inicial</label>
          <input
            id="horaInicial"
            v-mask="'99:99'"
            data-test-id="input-horainicial"
            :value="procedimento.horaInicial"
            type="text"
            class="form-control input-sm"
            name="horaInicial"
            placeholder="Hora inicial de realização do procedimento"
            @input="atualizaHora('horaInicial', $event.target.value)"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="horaFinal">53 - Hora final</label>
          <input
            id="horaFinal"
            v-mask="'99:99'"
            data-test-id="input-horafinal"
            :value="procedimento.horaFinal"
            type="text"
            class="form-control input-sm"
            name="horaFinal"
            placeholder="Hora final de realização do procedimento"
            @input="atualizaHora('horaFinal', $event.target.value)"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>54 - Código da tabela <sup>(1)</sup></label>
          <select
            v-model="procedimento.codigoTabela"
            data-test-id="select-procedimento-codigotabela"
            class="form-control input-sm"
          >
            <option disabled value=""> Selecione </option>
            <option
              v-for="tabela in tabelas"
              :key="tabela._id"
              :value="tabela.nome"
            >
              {{ tabela.nome }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
        <div
          :class="{
            'has-error':
              itemValidacao.codigo.$error || itemValidacao.nome.$error,
          }"
          class="form-group"
        >
          <label
            >55 - Código do procedimento / 56 - Descrição do procedimento
            <sup>(1)</sup></label
          >
          <BuscarSelecionar
            :classes-input="'form-control input-sm'"
            :lista="procedimentos"
            :selecionado="procedimentoSelecionado"
            :exibir-chave="false"
            :exibir="['codigoNome']"
            :minimo="1"
            @selecionar="selecionarProcedimento"
            @limpar="limparProcedimento"
            @recuperar="recuperarProcedimentos"
          />
          <span v-if="itemValidacao.codigo.$dirty">
            <span v-if="!itemValidacao.codigo.required" class="help-block">
              Campo obrigatório.
            </span>
          </span>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="quantidadeRealizada"
            >57 - Quantidade realizada <sup>(6)</sup></label
          >
          <input
            id="quantidadeRealizada"
            v-model="procedimento.qtdRealizada"
            v-mask="'999'"
            data-test-id="input-quantidaderealizada"
            :readonly="!verificaAcao('faturamento_guia')"
            type="number"
            class="form-control input-sm"
            placeholder="Quantidade em cobrança de um mesmo serviço/procedimento realizado"
            @change="recalcularGuia"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="viaAcesso">58 - Via de acesso</label>
          <select
            id="viaAcesso"
            v-model="procedimento.viaAcesso"
            data-test-id="select-viaacesso"
            class="form-control input-sm"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="viaAcesso in viasAcesso"
              :key="viaAcesso.codigo"
              :value="viaAcesso.codigo"
            >
              {{ viaAcesso.codigo }} - {{ viaAcesso.valor }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label>59 - Técnica utilizada</label>
          <select
            id="tecnica"
            v-model="procedimento.tecnicaUtilizada"
            data-test-id="select-tecnica"
            class="form-control input-sm"
          >
            <option disabled value="">Selecione</option>
            <option
              v-for="tecnica in tecnicas"
              :key="tecnica.codigo"
              :value="tecnica.codigo"
            >
              {{ tecnica.codigo }} - {{ tecnica.valor }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="reducaoAcrescimoPct">60 - % de redução/acréscimo</label>
          <input
            id="reducaoAcrescimoPct"
            v-model.number="procedimento.reducaoAcrescimoPct"
            v-mask="'money'"
            data-test-id="input-reducaoacrescimopct"
            type="text"
            class="form-control input-sm"
            placeholder="% de redução/acréscimo no caso de cirurgia múltipla/radiologia de múltiplas áreas"
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="valorUnitario">61 - Valor unitário (R$)</label>
          <input
            id="valorUnitario"
            v-mask="'money'"
            data-test-id="input-valorunitario"
            type="text"
            class="form-control input-sm"
            placeholder="Valor unitário em R$ do procedimento/serviço realizado"
            readonly
          />
        </div>
      </div>
      <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
        <div class="form-group">
          <label for="valorTotal">62 - Valor total (R$)</label>
          <input
            id="valorTotal"
            v-mask="'money'"
            data-test-id="input-valortotal"
            type="text"
            class="form-control input-sm"
            placeholder="Valor total em R$ do procedimento/serviço realizado"
            readonly
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import AwesomeMask from 'awesome-mask'
import moment from 'moment'
import numeral from 'numeral'
import { DatePicker } from 'uiv'

import BuscarSelecionar from '@/componentes/formulario/BuscarSelecionar'
import { dominioMixin } from '@/mixins/DominioMixin'
import ControleAcessoServico from '@/servicos/ControleAcessoServico'
import ConvenioServico from '@/servicos/ConvenioServico'
import MensagemServico from '@/servicos/MensagemServico'
import appStore from '@/stores'

const convenioServico = new ConvenioServico()
const controleAcessoServico = new ControleAcessoServico()
const mensagemServico = new MensagemServico()

export default {
  name: 'ProcedimentoRealizado',
  components: { BuscarSelecionar, DatePicker },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  props: {
    procedimento: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    guia: {
      type: Object,
      required: true,
    },
    validations: {
      type: Object,
      required: true,
    },
    visaoSimplificada: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      tabelas: [],
      tecnicas: [],
      viasAcesso: [],
      procedimentos: [],
      procedimentoSelecionado: this.procedimento,
    }
  },
  computed: {
    usuario() {
      return appStore.usuario
    },
    itemValidacao() {
      return this.obterItemValidacao()
    },
  },
  watch: {
    procedimento() {
      this.processarProcedimento()
    },
    'procedimento.codigo'() {
      this.processarProcedimento()
    },
    'guia.beneficiario.convenio'(novo, velho) {
      if (typeof velho._id !== 'undefined' && velho._id !== novo._id) {
        this.limparProcedimento()
        this.tabelas =
          this.guia.beneficiario.convenio &&
          this.guia.beneficiario.convenio.tabelas.length
            ? this.guia.beneficiario.convenio.tabelas
            : []
      }
    },
  },
  created() {
    if (
      this.guia.beneficiario.convenio &&
      this.guia.beneficiario.convenio.tabelas &&
      this.guia.beneficiario.convenio.tabelas.length
    ) {
      this.tabelas = this.guia.beneficiario.convenio.tabelas
    }

    this.recuperarValoresDominio('ViaAcesso').then((res) => {
      this.viasAcesso = res.valores
    })
    this.recuperarValoresDominio('TecnicaUtilizada').then((res) => {
      this.tecnicas = res.valores
    })
  },
  methods: {
    criarCampoCompativel(nome, erros = {}, touch = () => {}) {
      const errosCampo = Array.isArray(erros[nome]) ? erros[nome] : []
      return {
        $error: errosCampo.length > 0,
        $dirty:
          this.validations?.guia?.procedimentosRealizados?.procedimentos
            ?.$dirty || false,
        required: !errosCampo.some((erro) => erro.$validator === 'required'),
        $touch: touch,
      }
    },
    obterItemValidacao() {
      const colecao =
        this.validations?.guia?.procedimentosRealizados?.procedimentos
      const each = colecao?.$each
      const noop = () => {
        if (colecao && typeof colecao.$touch === 'function') {
          colecao.$touch()
        }
      }

      if (Array.isArray(each)) {
        return each[this.index] || {}
      }

      const erros = each?.$response?.$errors?.[this.index] || {}
      return {
        data: this.criarCampoCompativel('data', erros, noop),
        codigo: this.criarCampoCompativel('codigo', erros, noop),
        nome: this.criarCampoCompativel('nome', erros, noop),
      }
    },
    recalcularGuia(dados) {
      const vu = numeral(this.procedimento.valorUnitario).value()
      const qtd = numeral(this.procedimento.qtdRealizada).value()
      const valorTotal = vu * qtd
      this.procedimento.valorTotal = numeral(valorTotal).format('0,0.00')
      this.$emit('recalcular')
    },
    processarProcedimento() {
      if (
        this.procedimento.codigo &&
        this.procedimento.nome &&
        this.guia.beneficiario.convenio._id
      ) {
        this.tabelas =
          this.guia.beneficiario.convenio &&
          this.guia.beneficiario.convenio.tabelas.length
            ? this.guia.beneficiario.convenio.tabelas
            : []
        const tabela = this.tabelas.find(
          (t) => t.nome === this.procedimento.codigoTabela
        )
        convenioServico
          .recuperarProcedimentos({
            nome: this.procedimento.nome,
            skip: 0,
            limit: 1,
            orderBy: 'nome',
            codigo: this.procedimento.codigo,
            convenio: this.guia.beneficiario.convenio._id,
            idTabela: tabela._id,
          })
          .then((res) => {
            if (res.procedimentos.length) {
              const procedimento = res.procedimentos[0].procedimentos
              procedimento.codigoNome = `${procedimento.codigo} - ${procedimento.nome}`
              this.selecionarProcedimento(procedimento)
            }
          })
      }
    },
    selecionarProcedimento(procedimento) {
      this.procedimentoSelecionado = procedimento
      this.procedimento.nome = procedimento.nome
      this.procedimento.codigo = procedimento.codigo
      this.procedimento.codigoNome = `${procedimento.codigo} - ${procedimento.nome}`
      this.procedimento._id = procedimento._id
      this.procedimento.vazio = false

      if (procedimento.valor_fixo) {
        this.procedimento.valorFixo = procedimento.valor_fixo
      }

      if (procedimento.ch) {
        this.procedimento.ch = procedimento.ch
      }

      const vu = this.procedimento.ch
        ? this.procedimento.ch * this.guia.beneficiario.convenio.valorCH
        : this.procedimento.valorFixo
      this.procedimento.valorUnitario = numeral(vu).format('0,0.00')
      this.recalcularGuia()
    },
    limparProcedimento() {
      this.procedimentoSelecionado = {}
      this.procedimento.nome = ''
      this.procedimento.codigo = ''
      this.procedimento.codigoNome = ''
      this.procedimento.valorFixo = ''
      this.procedimento.ch = ''
      this.procedimento._id = ''
      this.procedimento.vazio = true
    },
    recuperarProcedimentos(filtro) {
      if (this.guia.beneficiario.convenio) {
        const codigo = new RegExp('^[0-9]+$').test(filtro.palavra)
          ? filtro.palavra
          : ''
        const nome = new RegExp('^[a-z]+$', 'i').test(filtro.palavra)
          ? filtro.palavra
          : ''
        const tabela = this.tabelas.find(
          (t) => t.nome === this.procedimento.codigoTabela
        )
        const data = {
          nome: nome,
          skip: (filtro.pagina - 1) * filtro.limite,
          limit: filtro.limite,
          orderBy: filtro.chave,
          codigo: codigo,
          convenio: this.guia.beneficiario.convenio._id,
          idTabela: tabela._id,
        }
        convenioServico.recuperarProcedimentos(data).then((res) => {
          this.procedimentos = []
          res.procedimentos.forEach((procedimento) => {
            const p = procedimento.procedimentos
            p.codigoNome = `${p.codigo} - ${p.nome}`
            this.procedimentos.push(procedimento.procedimentos)
          })
        })
      } else {
        mensagemServico.alerta('Informe o plano do beneficiário.')
      }
    },
    atualizaHora(campo, value) {
      const h = moment(value, 'HH:mm')

      if (value.length === 5 && h.isValid()) {
        this.procedimento[campo] = value
      }
    },
    dataParser(value) {
      return moment(value, 'DD/MM/YYYY').toDate().getTime()
    },
    verificaAcao(nome) {
      return controleAcessoServico.verificaAcao(nome)
    },
  },
}
</script>
